<template>
<!-- 能不能吃页面 -->
  <div class="can_eat_page">
    <div class="content" v-if="isShow">
      <Search :isShare="isShare"></Search>
      <section class="section" ref="articleListBox">
        <div class="classify" v-if="isShowSort">
          <SortingItem v-for="item in sortingDatas"
          :key="item.id" @handleSortingFn="sortingFn"
          :sortItem="item">
            <div slot="text" class="text">{{item.name}}</div>
          </SortingItem>
        </div>
        <!-- 黑白榜 -->
        <div class="announcement">
          <Caption type="normal">食物禁忌</Caption>
          <div class="matters">
            <BlackWhiteItem v-for="item in blackWhiteBtns"
            :blackWhiteItem="item"
            :monthAge="monthAge"
            :key="item.type"
            @handleblackWhiteFn="blackWhiteFn"></BlackWhiteItem>
          </div>
        </div>
        <!-- 精选推荐 -->
        <div class="recommend">
          <Caption type="excellent">精选推荐</Caption>
          <!-- <div class="recomend_list"> -->
          <van-list
            v-model="eatListLoading"
            :finished="eatListFinished"
            finished-text="——已经到底了哦——"
            :error.sync="eatListError"
            error-text="请求失败，点击重新加载"
            @load="onFoodLoad"
            >
            <ExcellentSelect v-for="(item, index) in recommendDatas" :key="index"
            @handleRecommendFn="recommendFn"
            :item="item"
            :id="item.id">
            <div class="introduction"  slot="nape">
              {{item.introduction}}
            </div>
            </ExcellentSelect>
          </van-list>
          <!-- </div> -->
        </div>
      </section>
      <footer class="footer"></footer>
    </div>
    <Empty v-else></Empty>
  </div>
</template>

<script>
import { Exposurer_eatTools } from '@/assets/js/Exposure'
import {getCookie,is_weixin,isUserLogin ,globalGoLogin} from '@/assets/js/common.js'
import canEatApi from "@/utils/axiosApi/canEatApi"

import Search from './components/Search'
import SortingItem from './components/SortingItem'
import BlackWhiteItem from './components/BlackWhiteItem'
import ExcellentSelect from './components/ExcellentSelect'
import Caption from './components/Caption'
import  Empty from './components/Empty'

  export default {
    name: 'canEatList',
    data() {
      return {
        bool: false,
        isShare: '', // 是否是分享链接进来的
        curMounth: null,
        babyInfo: localStorage.getItem('babyInfo') ? JSON.parse(localStorage.getItem('babyInfo')) : [],
        babyNums: this.getCookie('babyNum') ? JSON.parse(this.getCookie('babyNum')): '',
        babynumBir1: null,
        babyNum1: null,
        babynumBir2: null,
        babyNum2: null,
        isShow: true, // 推荐食物没有就整个页面不展示
        isShowSort: true, // 分类没有分类模块不展示
        monthAge: null,
        first1: null,
        second2: null,
        eatListLoading:false,
        eatListFinished:false,
        eatListError:false,
        Recommend:{
          dingZhi:true,
          phase:'',
          page:1,
          size:10
        },
        arr: [],
        sortingDatas: [],
        blackWhiteBtns: [{
          type: 0,
          title: '能吃',
          bgUrl: require('./../../assets/images/canEat/0_bg.png'),
          iconUrl: require('./../../assets/images/canEat/shape0.png')
        },
        {
          type: 1,
          title: '少吃',
          bgUrl: require('./../../assets/images/canEat/1_bg.png'),
          iconUrl: require('./../../assets/images/canEat/shape1.png')
        },
        {
          type: 2,
          title: '慎吃',
          bgUrl: require('./../../assets/images/canEat/2_bg.png'),
          iconUrl: require('./../../assets/images/canEat/shape2.png')
        },
        {
          type: 3,
          title: '禁吃',
          bgUrl: require('./../../assets/images/canEat/3_bg.png'),
          iconUrl: require('./../../assets/images/canEat/shape3.png')
        }],
        recommendDatas: [],
        box:null,
        scTop:0
      }
    },
    components: {
      Search,
      SortingItem,
      Caption,
      BlackWhiteItem,
      ExcellentSelect,
      Empty
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$store.commit("changeIncludes", ["canEatList"]);
        if (vm.is_weixin()) { // 微信中
          if (vm.getCookie("xmh_openid") == null
            || vm.getCookie("xmh_openid") == ""
          ) { // 判断有没有openId
            location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
          } else {
            vm.userOpenid = vm.getCookie('xmh_openid')
            vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            vm.wxJsSet.getUserInfoBywx(vm, function () {
              vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
              gio('setUserId', vm.UserInfo.crm_id);
              if (vm.UserInfo.mobile == null
                || vm.UserInfo.mobile == ""
                || vm.UserInfo.mobile == "null"
              ) { // 没有手机号 未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                  } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
              }
            }, function () {
              if (vm.UserInfo == null
                || vm.UserInfo == ""
                || vm.UserInfo.mobile == null
                || vm.UserInfo.mobile == ""
                || vm.UserInfo.mobile == "null"
              ) { // 没有手机号 未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                  } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
              }
            });
          }
        } else {
          vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (vm.getCookie("xmh_phone") == null
            || vm.getCookie("xmh_phone") == ""
            || vm.UserInfo == null
            || vm.UserInfo == ""
          ) { // 未登录
            sensors.login(vm.getCookie('xmh_unionid'))
            vm.profileShow = false;
            vm.loginShow = true;
          } else {
            sensors.login(vm.UserInfo.crm_id)
            if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
              if (vm.getCookie('xmh_nickname') == '') {
                vm.userName = vm.UserInfo.full_name
              } else {
                vm.userName = vm.getCookie('xmh_nickname')
              }
            } else {
              vm.userName = vm.UserInfo.full_name
            }
            vm.profileShow = true;
            vm.loginShow = true;
          }
        }
      })
    },
    mounted() {
      if(localStorage.getItem('babyNum')==0){
         this.Recommend.dingZhi=false
      }
      this.Recommend.phase=localStorage.getItem('monthAge')?localStorage.getItem('monthAge'):''
      this.isShare = this.$route.query.isShare ? this.$route.query.isShare : '' // 是否是分享
      this.getbir() // 获取本地存储宝宝生日
      this.getBabyBir() // 获取宝宝的年龄
      this.postSortList() // 获取食物分类数据
      // this.postRecommendList(this.Recommend) // 获取推荐数据
      this.shareFn() // 分享
      // 通过$refs获取dom元素
      this.box = this.$refs.articleListBox
      // 监听这个dom的scroll事件
      this.box.addEventListener('scroll', () => {
        this.scTop = this.$refs.articleListBox.scrollTop
      }, false)
      setTimeout(() => {
        const data = JSON.parse(localStorage.getItem("toolEatPoint")) || {};
        Exposurer_eatTools.observe('.can_eat_page', false, {
          Pregnancy_Weeks: data.Pregnancy_Weeks,
          Baby_Month: data.Baby_Month,
          Gestate_State: data.Gestate_State,
          Visit_Channel: data.Visit_Channel,
          module_name:'能不能吃',
          per_page_name:'能不能吃',
          per_module_name:'能不能吃'
        })
      }, 200)
    },
    activated () {
      this.$refs.articleListBox.scrollTop = localStorage.getItem('nbnc_scTop') ? localStorage.getItem('nbnc_scTop') : 0
    },
    methods: {
      is_weixin, getCookie, isUserLogin,
      shareFn() {
        var that = this;
        var shareUrl = location.href.split('#')[0] + "?isShare=1"
        var shareDataParams = {
          shareLink: shareUrl,
          shareDesc: '婴幼儿/孕育女性/老年人，什么推荐吃，什么不能吃？快来查一查吧！',
          shareTitle: '能不能吃',
          imgUrl: "https://image-mom.feihe.com/wxshare/nengbunengchi.png",//必须是绝对路径
        }
        this.wxJsSet.wxShare("fx", shareDataParams, this);
      },
      getbir() { // 获取符合条件的宝宝生日
        for (var i = 0; i < this.babyInfo.length; i++) {
          if (this.babyInfo[i].num == '1') {
            this.babynumBir1 = this.babyInfo[i].birth;
            this.babyNum1 = this.babyInfo[i].num;
          } else if (this.babyInfo[i].num == '2') {
            this.babynumBir2 = this.babyInfo[i].birth;
            this.babyNum2 = this.babyInfo[i].num;
          }
        }
      },
        // 获取宝宝bir
        getBabyBir() {
          let _this = this
          this.$http.post(
            "/parentingTips/getTimeWithBirth",
            {},
            { first: this.babynumBir1, second: this.babynumBir2 },
            res => {
              // 如果当前选择第二胎处理逻辑
              if (this.babyNums == 2) {
                this.handleMonthSplit(res.data.secondtime);
              } else {
                // 如果没有获取到则从localStorage获取
                if (JSON.parse(localStorage.getItem('babyNum')) == 2
                  && this.babyNums != 1
                ) {
                  if (
                    new Date(this.babyInfo[0].birth).getTime() >
                    new Date(this.babyInfo[1].birth).getTime()
                  ) {
                    this.handleMonthSplit(res.data.firsttime);
                  } else if (
                    new Date(this.babyInfo[0].birth).getTime() <
                    new Date(this.babyInfo[1].birth).getTime()
                  ) {
                    this.handleMonthSplit(res.data.secondtime);
                  }
                } else {
                  this.handleMonthSplit(res.data.firsttime);
                }
              }
            })
        },
      handleMonthSplit(data) {
        // 根据传参标识(无/0=备孕,1=孕期,2=月子,3=哺乳期,4=婴幼儿,5=未成年)
        console.log(data);
        if (data.indexOf('岁') > -1){
          let yer =  Number(data.split('岁')[0])
          if(yer>=3){
            this.monthAge = 5
            localStorage.setItem('monthAge',this.monthAge)
          }else if(yer<3){
            this.monthAge = 4;
            localStorage.setItem('monthAge',this.monthAge)
          }
          console.log(this.monthAge);
        } else if(data.indexOf('月') > -1) {
          this.handleMonthAge(data);
        } else {
          this.monthAge = 1;
          localStorage.setItem('monthAge',this.monthAge)
        }
      },
      handleMonthAge(data) {
        let month =  Number(data.split('月')[0]);
        if (month < 1) {
          this.monthAge = 2;
          localStorage.setItem('monthAge',this.monthAge)
        } else if (1 <= month && month < 6) {
          this.monthAge = 3;
          localStorage.setItem('monthAge',this.monthAge)
        } else if (month >= 6) {
          this.monthAge = 4;
          localStorage.setItem('monthAge',this.monthAge)
        }
      },
      async postSortList() { // 获取食物分类数据
        await canEatApi.getSortApi({}, (res) => {
          try {
            if (res.code == '200') {
              this.sortingDatas = res.data
              if(this.sortingDatas
                && this.sortingDatas.length > 0
              ) {
                this.isShowSort = true
              } else {
                this.isShowSort = false
              }
            }
          }
          catch(err) {
            console.log(err, 'err')
            return
          }
        })
      },
      onFoodLoad(){
        // postRecommendList(this.Recommend)
        canEatApi.getFoodListApi(this.Recommend, (res) => {
          if (res.code == '200') {
            this.recommendDatas = this.recommendDatas.concat(
              res.data.content
          );
          this.eatListLoading = false;
          if(this.recommendDatas
              && this.recommendDatas.length > 0
            ) {
              this.isShow = true
            } else {
              this.isShow = false
            }
            if (
              res.data.content.length < 10
              ) {
              this.eatListFinished = true;
              } else {
              this.Recommend.page += 1;
              }
          } else {
            this.eatListLoading = false;
            this.eatListError = true;
          }
        })
      },
      async postRecommendList(comData) { // 获取推荐数据
        await canEatApi.getFoodListApi({dingZhi: comData.dingZhi, phase: comData.phase,page:comData.page,size:comData.size}, (res) => {
          if (res.code == '200') {
            this.recommendDatas = res.data.content
            if(this.recommendDatas
                && this.recommendDatas.length > 0
              ) {
                this.isShow = true
              } else {
                this.isShow = false
              }
          }
        })
      },
      // isRegister()  { // 点页面任何位置触发,判断是否已经注册
      //   if(this.isUserLogin()) { // 未zhuce
      //     this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
      //   } else {
      //   }
      // },
      sortingFn(id, name) { // 点击食物分类跳相应的分类列表
        localStorage.setItem("nbnc_scTop", this.scTop);
        sensors.track('Eatable_ClassificationClick', {
          Classification_Name: name,
          module_name:'能不能吃',
          per_page_name:'能不能吃',
          per_module_name:'能不能吃'
        })

        if(this.isUserLogin()) { // 未zhuce
          // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
          globalGoLogin()
        } else {
          this.$router.push({
            path: '/foodGroups',
            query: {
              classifyId: id,
              name: name
            }
          })
        }
      },
      blackWhiteFn(type, monthAge, title) { // 点击黑白榜页面
        localStorage.setItem("nbnc_scTop", this.scTop);
        sensors.track('Eatable_BlackList_Click', {
          Eatable_Name: title,
          module_name:'能不能吃',
          per_page_name:'能不能吃',
          per_module_name:'能不能吃'
        })

        if(this.isUserLogin()) { // 未zhuce
          // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
          globalGoLogin()
        } else {
          if(!monthAge) {
            this.$router.push({
              path: `/grayList?edibleProposal=${type}`
            })
          } else {
            this.$router.push({
              path: `/grayList?edibleProposal=${type}&monthAge=${monthAge}`
            })
          }
        }
      },
      recommendFn(id, nape) { // 点击精选商品跳详情页面
        sensors.track('Eatable_Recommend_Click', {
          FoodName: nape,
          module_name:'能不能吃',
          per_page_name:'能不能吃',
          per_module_name:'能不能吃'
        })
        localStorage.setItem("nbnc_scTop", this.scTop);
        if(this.isUserLogin()) { // 未zhuce
          // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
          globalGoLogin()
        } else {
          this.$router.push({
            path: `/canEatDetail/${id}`,
            query: {
              nape: nape
            }
          })
        }
      }
    },
  }
</script>

<style lang="less" scoped>
.can_eat_page {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F7F7F7;
  .section {
    width: 100%;
    flex: 1;
    overflow-y: scroll;
    margin-top: 56px;
    &::-webkit-scrollbar {
      display: none;
    }
    .classify {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 14px 0 10px;
      box-sizing: border-box;
      background: #FFFFFF;
      }
      .announcement { // 黑白榜
        width: 100%;
        padding: 3px 12px 20px;
        box-sizing: border-box;
        margin-top: 10px;
        background: #FFFFFF;
        .matters {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
        }
      }
      .recommend { // 精品推荐
         width: 100%;
         padding: 0 12px;
         box-sizing: border-box;
         .recomend_list {
           width: 100%;
           .introduction {
              width: 100%;
              background: #FFFFFF;
              display: -webkit-box;
              overflow: hidden;
              word-break: break-all;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              font-size: 12px;
              color: #999999;
              height: 19px;
              line-height: 26px; // 下面icons给margin边距这里得+margin: 7;
              font-weight: 400;
            }
         }
      }
  }
}
</style>
